export default "__VITE_ASSET__CwRWpa9j__"